<template>
  <div id="cloud-tags-page">
    <div class="cloud-tags-body card">
      <div class="cloud-tags-card">
        <div class="cloud-tags-card-header">
          <h4 class="cloud-tags-card-header-text">Nuvem TAG's |</h4>
          <p>
            Use as Tag's abaixo para definir o que será preenchido pelo sistema.
          </p>
        </div>
        <div class="cloud-tags">
          <div class="wise-tags" v-for="(tag, index) in tags" :key="index">
            <span>{{ tag.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  created() {
    this.loadTags();
    this.loadCategoriesMessage();
  },
  computed: {
    ...mapGetters({
      userData: 'getUserData',
      tags: 'getTags',
      categories: 'getCategories',
    }),
  },
  methods: {
    ...mapActions(['loadTags', 'loadCategoriesMessage']),
  },
};
</script>

<style scoped>
.card {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card .card-header.borderless {
  border-bottom: 0 solid transparent;
}

.card .card-header.borderless + .card-block,
.card .card-header.borderless + .card-block-big,
.card .card-header.borderless + .card-block-small {
  padding-top: 0;
}
.cloud-tags-body {
  background: white;
  padding: 20px;
}
.cloud-tags-card-header {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 5px;
}
.cloud-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.wise-tags {
  background: #019ead;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
